// @ts-nocheck
/* eslint-enable */
import React from 'react';
import Button from 'app/shared/core/Button';
import IconInstantTour from 'images/icons/instant-tour-teal.svg';

interface BookTourNowButtonV2Props {
  showContactButton?: boolean;
  onClick?: () => void;
}

const BookTourNowButtonV2 = React.forwardRef<HTMLButtonElement, BookTourNowButtonV2Props>(({ onClick }, ref) => {
  return (
    <Button
      ref={ref}
      onClick={onClick}
      btnType={'primary-outline'}
      rounded={false}
      full
      bold
      size={'lg'}
      iconGap="xs"
      icon={{ src: IconInstantTour, width: '22px', height: '20px', alt: '' }}
      data-testid="book-tour-now-button"
    >
      Book tour now
    </Button>
  );
});

BookTourNowButtonV2.displayName = 'BookTourNowButtonV2';

export default BookTourNowButtonV2;
